<template>
  <div v-if="progress.length > 0 && (userData.groupname !== 'psd' || userData.groupname !== 'cnt' )">
    <div>
      <b-row>
        <b-col
          lg="6"
          md="6"
          sm="6"
        >
          <span style="color:white; text-align: left; font-size:24px;">
            <svg
              width="20"
              height="38"
              viewBox="0 0 20 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.51426 0C2.49712 0 0.857117 1.56953 0.857117 3.5V19.25C0.857117 24.0844 4.94854 28 9.99997 28C15.0514 28 19.1428 24.0844 19.1428 19.25V3.5C19.1428 1.56953 17.5028 0 15.4857 0H4.51426ZM9.99997 17.5C11.5143 17.5 12.7428 18.6758 12.7428 20.125C12.7428 21.5742 11.5143 22.75 9.99997 22.75C8.48569 22.75 7.25712 21.5742 7.25712 20.125C7.25712 18.6758 8.48569 17.5 9.99997 17.5ZM7.25712 13.125C7.25712 11.6758 8.48569 10.5 9.99997 10.5C11.5143 10.5 12.7428 11.6758 12.7428 13.125C12.7428 14.5742 11.5143 15.75 9.99997 15.75C8.48569 15.75 7.25712 14.5742 7.25712 13.125ZM9.99997 3.5C11.5143 3.5 12.7428 4.67578 12.7428 6.125C12.7428 7.57422 11.5143 8.75 9.99997 8.75C8.48569 8.75 7.25712 7.57422 7.25712 6.125C7.25712 4.67578 8.48569 3.5 9.99997 3.5Z"
                fill="url(#paint0_linear_801_13998)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_801_13998"
                  x1="9.99997"
                  y1="0"
                  x2="9.99997"
                  y2="28"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FE8592" />
                  <stop
                    offset="0.588542"
                    stop-color="#FB0000"
                  />
                </linearGradient>
              </defs>
            </svg> <span v-if="userData.department === '0'">ระบบจราจรอัจฉริยะ (ทั่วประเทศ)</span>
            <span v-else>ระบบจราจรอัจฉริยะ</span>
          </span>
        </b-col>
        <b-col
          lg="6"
          md="6"
          sm="6"
          class="text-sm-right"
        >
          <b-link
            v-if="userData.department === '0'"
            to="/traffic-total"
          >
            <span style="text-align: right; color: #00B058; font-size:20px; text-decoration: underline;">
              ดูเพิ่มเติม
            </span>
            <feather-icon
              size="30"
              icon="ChevronRightIcon"
              style="color: #00B058; margin-bottom: 3px;"
            />
          </b-link>
        </b-col>
      </b-row>
    </div>
    <b-row class="match-height">
      <!-- frame 5 Top จุดติดตั้งไฟจราจรอัจฉริยะสูงสุด -->
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="6"
        xs="6"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 100%; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <span style="font-size:20px; color: #fff; font-weight: 600;">5 Top ปริมาณจราจรสูงสุด</span>
            <!-- <em>word wrap</em> -->
          </div>

          <b-row
            v-for="(item, index) in progress"
            :key="index"
            style="margin-top:10px"
            class="mt-2"
          >
            <b-col
              lg="6"
              md="6"
              xs="6"
            >
              <label style="color: #ffffff; font-size: 18px; width: 110%;">{{ index+1 +'. ' }} {{ item.detail }}</label>
              <b-progress
                :value="item.Total"
                :max="progress[0].Total + 10000"
                precision="2"
                class="progress8"
              />
            </b-col>
            <b-col
              lg="3"
              style="text-align: center; margin-top: 20px;"
            >
              <span style="color:#ffffff; font-size: 17px;">{{ item.Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} คัน/วัน</span>
            </b-col>
            <b-col
              lg="3"
              style="text-align: left; margin-top: 20px;"
            >
              <span style="color:#ffffff; font-size: 17px;">{{ item.Total_PCU.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} PCU/Day</span>
            </b-col>
          </b-row>

        </b-card>
      </b-col>

      <!-- frame 5 Top ประเภทยานพาหนะการจราจร -->
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="6"
        xs="6"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 100%; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <span style="font-size:20px; color: #fff; font-weight: 600;">5 Top ประเภทยานพาหนะ</span>
            <!-- <em>word wrap</em> -->
          </div>

          <b-row
            v-for="(itemT, indexT) in progressT.slice(0, 5)"
            :key="indexT"
            style="margin-top: 30px;"
          >
            <b-col
              lg="9"
            >
              <label style="color: #ffffff; font-size: 18px; width: 110%;">{{ indexT+1 +'. ' }} {{ itemT.typeName }}</label>
              <b-progress
                v-if="itemT.typeName === 'รถยนต์'"
                :value="itemT.countNum"
                :max="progressT[0].countNum + 12000"
                precision="2"
                class="progress1"
              />
              <b-progress
                v-if="itemT.typeName === 'รถจักรยานยนต์'"
                :value="itemT.countNum"
                :max="progressT[0].countNum + 12000"
                precision="2"
                class="progress2"
              />
              <b-progress
                v-if="itemT.typeName === 'รถกระบะ'"
                :value="itemT.countNum"
                :max="progressT[0].countNum + 12000"
                precision="2"
                class="progress3"
              />
              <b-progress
                v-if="itemT.typeName === 'รถแท็กซี่'"
                :value="itemT.countNum"
                :max="progressT[0].countNum + 12000"
                precision="2"
                class="progress4"
              />
              <b-progress
                v-if="itemT.typeName === 'รถบรรทุก'"
                :value="itemT.countNum"
                :max="progressT[0].countNum + 12000"
                precision="2"
                class="progress5"
              />
              <b-progress
                v-if="itemT.typeName ==='รถพ่วง'"
                :value="itemT.countNum"
                :max="progressT[0].countNum + 12000"
                precision="2"
                class="progress6"
              />
              <b-progress
                v-if="itemT.typeName ==='รถบัส'"
                :value="itemT.countNum"
                :max="progressT[0].countNum + 12000"
                precision="2"
                class="progress7"
              />
            </b-col>
            <b-col
              lg="3"
              style="text-align: center;"
            >
              <span style="color:#ffffff; font-size: 17px;">{{ itemT.countNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} คัน</span>
            </b-col>
          </b-row>

        </b-card>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BLink, BProgress, BCard,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BProgress,
    BCard,
  },
  data() {
    return {
      progress: [],
      progressT: [],
      colorprogressT: [
        {
          color: ['#579BFE', '#DC48FF', '#8246FE', '#FE447A', '#4EAF51'],
        },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getPieDataRight()
    this.getPieDataLeft()
    this.interval = setInterval(() => {
      this.getPieDataRight()
      this.getPieDataLeft()
    }, 5000)
  },
  methods: {
    // ด้านขวา 5 Top จุดติดตั้งป้ายจราจรสูงสุด
    getPieDataRight() {
      axios
        .post('/getTop5TrafficTotal', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
        // eslint-disable-next-line prefer-destructuring
          this.progress = response.data
          // console.log(this.progress)
        })
        .catch(error => {
          console.log(error)
        })
    },

    // ด้านซ้าย 5 Top ประเภทยานพาหนะการจราจร
    getPieDataLeft() {
      axios
        .post('/getTop5TypeTrafficTotal', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
        // eslint-disable-next-line prefer-destructuring
          this.progressT = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    for() {
      setTimeout(() => this.progressT.slice(0, 5).forEach((value, i) => {
        this.stream(value, i)
      }), 1000)
    },
  },
}
</script>

<style lang="scss">
  .progress1 .progress-bar{background: #579BFE;}
  .progress2 .progress-bar{background: #DC48FF;}
  .progress3 .progress-bar{background: #8246FE;}
  .progress4 .progress-bar{background: #FE447A;}
  .progress5 .progress-bar{background: #4EAF51;}
  .progress6 .progress-bar{background: #FF805D;}
  .progress7 .progress-bar{background: #FDFF01;}
  .progress8 .progress-bar{background: linear-gradient(90deg, #00B058 46.03%, #99FBCA 100%)}
  /* .progress9 .progress-bar{background: linear-gradient(90deg, #00aab0 46.03%, #99f4fb 100%)} */
  </style>
